{
  "name": "application-host",
  "type": "module",
  "version": "0.0.1-6-omsorg-a21-a22.8",
  "scripts": {
    "install": "cp ./package.json ./src/assets",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "ng": "ng",
    "lint": "ng lint",
    "style-lint": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.2",
    "@angular/cdk": "^22.2.2",
    "@angular/common": "^22.2.2",
    "@angular/compiler": "^22.2.2",
    "@angular/core": "^22.2.2",
    "@angular/forms": "^22.2.2",
    "@angular/material": "^22.2.2",
    "@angular/platform-browser": "^22.2.2",
    "@angular/platform-browser-dynamic": "^22.2.2",
    "@angular/router": "^22.2.2",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.2",
    "@sparbanken-syd/auth-backend": "^2.7.1",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.1.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@types/node": "^22",
    "@vitest/coverage-v8": "5.0.3",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.12.0",
    "jsdom": "^30.1.1",
    "postcss": "^8.5.4",
    "postcss-scss": "^4.0.9",
    "stylelint": "^17.16.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.33.1",
    "vite": "^8.3.3",
    "vitest": "^5.0.3"
  }
}
